import { getDecryptedValue } from "../config/lenderEncryption";
import AfterOnboardAPI from "../services/AfterOnboardAPI";
import { getEnvironment } from "../utils/environment";

const { PRODUCT } = getEnvironment();

const { getLenderPaymentDetailsAPI } = new AfterOnboardAPI();

// Rozarpay Mandate
export const rozarPayMandate = async (data) => {
  const lenderPaymentDetails = await getLenderPaymentDetailsAPI();

  const keys = lenderPaymentDetails?.data.lenderCreds?.["RazorPay Emandate"]?.razorpay_disbursal_key_id;
  const decryptedKey = await getDecryptedValue(keys);

  const script = document.createElement("script");
  script.src = "https://checkout.razorpay.com/v1/checkout.js";
  script.async = true;
  document.body.appendChild(script);

  const host = window.location.href.split("/");

  script.onload = () => {
    const options = {
      key: decryptedKey,
      customer_id: data.customer_id,
      order_id: data.order_id,
      recurring: 1,
      callback_url: host[0] + "//" + host[2] + "/emandate-status",
      notes: {
        disableWebhook: true,
      },
      theme: {
        color: "#182bda",
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  };
};

// Rozarpay Loan Payment
export const rozarLoanPayment = async (data) => {
  const lenderPaymentDetails = await getLenderPaymentDetailsAPI();
  const keys = lenderPaymentDetails?.data.lenderCreds?.["RazorPay Emandate"]?.razorpay_disbursal_key_id;
  const decryptedKey = await getDecryptedValue(keys); // put in key

  const lenderName = lenderPaymentDetails?.data.lenderDetails?.displayName; // put in name

  const { amount, email, logo, mobile, name, orderId } = data;

  const script = document.createElement("script");
  script.src = "https://checkout.razorpay.com/v1/checkout.js";
  script.async = true;
  document.body.appendChild(script);

  const host = window.location.href.split("/");

  script.onload = () => {
    const options = {
      key: process.env.REACT_APP_ROZAR_PAY_KEY,
      amount: amount,
      currency: "INR",
      name: PRODUCT === "ramfincorp_api" ? "Ram Fincorp" : "Kamakshi Money",
      description: "",
      image: logo,
      order_id: orderId,
      callback_url: host[0] + "//" + host[2] + "/payment-status",
      prefill: {
        name: name,
        email: email,
        contact: mobile,
      },
      notes: {
        disableWebhook: true,
      },
      theme: {
        color: "#182bda",
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  };
};
